import { useContext } from "react";
import { ContextProviderWrapper } from "../../../components/Context";
import { shortenAddress } from "../../../utils/addressUser";
import { HistoryContainer } from "../History/styled";
import TableCommon from "../../../components/Common/TableCommon";
import { UserProfile } from "../../../types/profile";
import moment from "moment";
import { ContentTableMobile } from "../../Avax/Leaderboard/styled";

interface ReferralProps {
  userProfile: UserProfile | null;
}

export const Referral = ({ userProfile }: ReferralProps) => {
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;

  const headingData = !isMobile
    ? [
        {
          name: `Time`,
          dataIndex: "createdAt",
          key: "createdAt",
          render: (data: any) => {
            return <p>{moment(data).format("MMMM DD , YYYY")}</p>;
          },
        },
        {
          name: `Referral Code`,
          dataIndex: "referralCode",
          key: "referralCode",
          render: (data: any) => {
            return <p>{data}</p>;
          },
        },
        {
          name: `Name`,
          dataIndex: "name",
          key: "name",
          render: (data: any) => {
            return <p>{shortenAddress(data)}</p>;
          },
        },
        {
          name: `Status`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{data?.isJoined ? "Joined" : "Not yet"}</p>;
          },
        },
        {
          name: `Address`,
          dataIndex: "address",
          key: "address",
          render: (data: any) => {
            return (
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  justifyContent: "center",
                }}
              >
                <img
                  src="/assets/images/profile/icn_referral.svg"
                  width={16}
                  height={16}
                  loading="lazy"
                  alt="Referrals"
                />
                {shortenAddress(data)}
              </p>
            );
          },
        },
      ]
    : [
        {
          name: `Transaction`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <ContentTableMobile className={theme}>
                <div className="content-right">
                  <div className="block-address">
                    <p>{moment(data.createdAt).format("MMMM DD - HH:mm")}</p>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Address: <span>{shortenAddress(data.address)}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Referral Code: <span> {data.referralCode}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Name: <span> {shortenAddress(data.name)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </ContentTableMobile>
            );
          },
        },
      ];

  const moveToDetail = "leaderboard";
  return (
    <HistoryContainer>
      <TableCommon
        data={userProfile?.referrals}
        heading={headingData}
        moveTo={moveToDetail}
        pagination={
          userProfile && userProfile?.referrals?.length > 10 ? true : false
        }
      />
    </HistoryContainer>
  );
};

export default Referral;
